import { memo } from "react";

import { IconGitMerge } from "@tabler/icons";
import { useTheme } from "styled-components";

import { Dialog } from "@sso/constant";
import { useAppDispatch, useAppSelector } from "@sso/hooks/useRedux";
import { openDialog } from "@sso/store/slices/dialog";
import { selectMergeOrganisations } from "@sso/store/slices/organisation";
import { Badge } from "@sso/ui/Badge";
import { IconButton } from "@sso/ui/IconButton";

export const OrganisationsTableMerge = memo(() => {
  const theme = useTheme();
  const dispatch = useAppDispatch();
  const mergeOrgsArray = useAppSelector(selectMergeOrganisations);

  const handleMergeOrganisation = () => {
    dispatch(openDialog({ type: Dialog.MERGE_ORGANISATIONS }));
  };

  return (
    <Badge badgeNumber={mergeOrgsArray.length} bgColor={theme.colors.warning.dark} right="0">
      <IconButton title="Merge Organisations" disabled={mergeOrgsArray.length <= 1} onClick={handleMergeOrganisation}>
        <IconGitMerge />
      </IconButton>
    </Badge>
  );
});
